import {useEffect} from 'react'
import {useSelector} from 'react-redux'
import {Outlet} from 'react-router'
import {changeLanguage} from '~/initializers/i18n'
import {NavigationHeader} from '~/components'
import {useFetchRecords} from '~/services'

export const Root = () => {
	const language = useUserLanguage()
	useFetchRecords()

	return (
		<main key={language}>
			<NavigationHeader />
			<Outlet />
		</main>
	)
}

const useUserLanguage = () => {
	const {language} = useSelector(state => state.auth.user)

	useEffect(() => {
		changeLanguage(language || 'en')
	}, [language])

	return language
}
